import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export function sliders(selector, properties) {
  const swiperSliders = document.querySelectorAll(selector);
  const swiperInstances = []; // To store Swiper instances

  swiperSliders.forEach((slider) => {
    const instance = new Swiper(slider, {
      modules: [Navigation, Pagination, EffectFade],
      ...properties,
    });
    swiperInstances.push(instance); // Collect the instance
  });

  return swiperInstances; // Return instances instead of DOM elements
}

export function slider(selector, properties) {

    const instance = new Swiper(selector, {
      modules: [Navigation, Pagination, EffectFade],
      ...properties,
    });

  return instance; // Return instances instead of DOM elements
}
